﻿import {Word} from './word';

export class SubCategory {
    id: string;
    name: string;
    words: Word[];

    constructor(json: any) {
        this.id = json.id;
        this.name = json.name;
        this.words = json.words;
    }
}
